import {
    GetTasksRequestType,
    GetMyDayTasksRequestParams,
    GetDueDateTasksRequestParams,
    GetFolderTasksRequestParams,
    GetTasksRequestParams,
} from '../schema/request/GetTasksRequestParams';

export function isGetMyDayTasksRequestParams(
    requestParams: GetTasksRequestParams
): requestParams is GetMyDayTasksRequestParams {
    return requestParams && requestParams.type === GetTasksRequestType.MyDay;
}

export function isGetDueDateTasksRequestParams(
    requestParams: GetTasksRequestParams
): requestParams is GetDueDateTasksRequestParams {
    return requestParams && requestParams.type === GetTasksRequestType.DueDate;
}

export function isGetFolderTasksRequestParams(
    requestParams: GetTasksRequestParams
): requestParams is GetFolderTasksRequestParams {
    return requestParams && requestParams.type === GetTasksRequestType.FolderId;
}
